import * as React from "react";
import { trim } from "lodash";
const md5 = require("md5");

enum Validity {
  VALID,
  INVALID,
  LOADING,
}

function getGravatarUrl(email: string, size: number): string {
  const gravatarEmail = trim(email).toLowerCase();
  const id = gravatarEmail.includes("@") ? md5(gravatarEmail) : gravatarEmail;
  return `https://secure.gravatar.com/avatar/${id}?s=${size}&d=404`;
}

function useGravatar(email: string, size: number): { isLoading: boolean; gravatarUrl: string | undefined } {
  const [gravatarValidity, setGravatarValidity] = React.useState<Validity>(Validity.LOADING);

  const gravatarUrl = getGravatarUrl(email, size);

  React.useEffect(() => {
    // prevent the component from unmounting while setting state˝
    let unmounted = false;
    fetch(gravatarUrl, { method: "HEAD" })
      .then((response) => {
        if (response.status !== 404 && unmounted === false) {
          setGravatarValidity(Validity.VALID);
        } else if (unmounted === false) {
          setGravatarValidity(Validity.INVALID);
        }
      })
      .catch(() => {
        if (unmounted === false) {
          setGravatarValidity(Validity.INVALID);
        }
      });

    return () => {
      unmounted = true;
    };
  });
  return {
    isLoading: gravatarValidity === Validity.LOADING,
    gravatarUrl: gravatarValidity === Validity.VALID ? gravatarUrl : undefined,
  };
}

export { useGravatar };
